import { Components } from "@thisgorilla/primate-ds";
import { useContext, useEffect, useRef, useState } from "react";
import { CreatePostModalContext } from "../../..";
import { useContainerSize } from "../../../../../../../../../hooks/useContainerSize";
import { useAppSelector } from "../../../../../../../../../redux";
import { VideoPlayer } from "../../../../../../../../Common";
import { PreviewBody, PreviewHeading, VideoContainer } from "./style";

const VideoPreview = ({ video_id }: { video_id: string }) => {
  const ref = useRef(null);
  const size = useContainerSize(ref);
  const [height, setHeight] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (ref?.current) {
      setHeight((ref?.current as Element)?.scrollHeight ?? 0);
    }
  }, [size, isOpen]);

  const { formik } = useContext(CreatePostModalContext);
  const { video_title, video_description } = formik.values;

  const { uploadedVideo } = useAppSelector((state) => state.postVideo);

  return (
    <VideoContainer $isShow={isOpen}>
      <PreviewHeading>
        <Components.Label kind="Fill" text="Preview" color="Primary" />
        <Components.IconButton
          kind="Secondary"
          iconType={isOpen ? "ChevronUp" : "ChevronDown"}
          disabled={false}
          size="Small"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        />
      </PreviewHeading>
      <PreviewBody ref={ref} height={isOpen ? height + 25 : 0} $isOpen={isOpen}>
        <VideoPlayer
          video_id={video_id}
          video_title={video_title}
          video_description={video_description}
          duration={uploadedVideo.duration}
          isViewOnly={true}
        />
      </PreviewBody>
    </VideoContainer>
  );
};

export default VideoPreview;
